import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CalendarComponent } from '../components/calendar/calendar.component';

const routes: Routes = [
  {
      path: '',
      component: CalendarComponent,
      // canActivate: [AuthGuard],
      data: { title: 'Apollo - Calendar' }
    },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CalendarModuleRoutingModule { }
